function DocumentTitle(title) {
  document.title = title;
}

export default DocumentTitle;
